import { render, staticRenderFns } from "./CancelBookingDetail.vue?vue&type=template&id=5c7b671f"
import script from "./CancelBookingDetail.vue?vue&type=script&lang=js"
export * from "./CancelBookingDetail.vue?vue&type=script&lang=js"
import style0 from "./CancelBookingDetail.vue?vue&type=style&index=0&id=5c7b671f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports